<template>
    <div>
        <el-container>
            <el-header>
                <el-row><el-col :span="24"><div class="grid-content bg-purple-dark"><span class="word-v-middle">系统导航</span></div></el-col></el-row>
            </el-header>
        </el-container>


    <div class="dataTag">
        <div class="handle">
            <div class="fl">
                <img src="@/assets/img/dataIcon.png" style="vertical-align: middle;" />
                <span class="" style="display: inline-block; vertical-align: middle;">数据列表</span>
            </div>
            <div class="fr">
                <el-button size="mini" type="primary" @click="handleConfirmDB">进入后台</el-button>
            </div>
        </div>

        <!--列表内容-->
        <div class="tableData" style="text-align: center;">
            <el-table
                    ref="multipleTable"
                    :data="tableData"
                    border
                    style="width: 100%;border-bottom: 1px solid #ddd;">
                <el-table-column type="index" label="序号" width="200px">
                </el-table-column>
                <el-table-column prop="name" label="网站名字" width="250px">
                </el-table-column>
                <el-table-column prop="url" label="网址" width="250px">
                </el-table-column>
                <el-table-column label="操作">
                     <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleConfirm(scope.$index, scope.row)">进入</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
    </div>
</template>

<script>
    export default {
        name: "clientMain",
        data() {
            return {
                tableData: [],
            }
        },
        methods: {
            getData() {
                this.$http.get("nav/getUrl/", {emulateJson: true}).then(
                    (success) => {
                        this.tableData = success.body.data
                        console.log(this.tableData)
                    }
                )
            },
            handleConfirm: function (index, row) {
                window.open(this.checkUrl(row.url))
            },
            checkUrl: function (url) {
                var path = url.substring(0, 4)
                if (path != "http") {
                    return "http://" + url
                }
                return url
            },
            handleConfirmDB:function () {
                window.location.href = '/navbg'
            }
        },
        mounted() {
            this.getData()
        }
    }
</script>

<style scoped>
    .dataTag{
        width: 1200px;
        border: 1px solid #ccc;
        margin: auto;
        margin-top: 30px;
    }
    .dataTag .handle{
        height: 60px;
        line-height: 60px;
        background: #ededed;
        padding: 0 40px;
        border-bottom: 1px solid #ccc;
    }
    .fl {
        float: left;
    }
    .fr {
        float: right;
    }
    .cf {
        overflow: hidden;
    }
    .title{
        padding: 20px 0;
    }
    .bg-purple-dark {
        background: #99a9bf;
    }
    .grid-content {
        border-radius: 4px;
        min-height: 50px;
    }
    .word-v-middle{
        margin-bottom: 0;
        font-size: 24px;
        min-height: 31px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 31px;
        margin-top: 5px;
        color: #000000;
        white-space: normal;
    }
</style>
